import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import registerServiceWorker, { unregister } from './registerServiceWorker';
import './index.css';

ReactDOM.render(<App />, document.getElementById('root'));
//registerServiceWorker();
unregister();



// WEBPACK FOOTER //
// ./src/index.js